import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import Registration from "../views/Registration.vue";
// import ConfirmAge from "../views/ConfirmAge.vue";
import RegisterForEvent from "../views/RegisterForEvent.vue";
import SocialLead from "../views/SocialLead.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/registration",
    name: "registration",
    component: Registration,
  },
  // {
  //   path: "/",
  //   name: "confirm-age",
  //   component: ConfirmAge,
  // },
  {
    path: "/register-for-event",
    name: "RegisterForEvent",
    component: RegisterForEvent,
  },
  {
    path: "/jameson",
    name: "SocialLead",
    component: SocialLead,
  },
  {
    path: "/punch-competition",
    name: "PunchCompetition",
    component: () => import("@/views/PunchCompetition.vue"),
  },
  {
    path: "/punch",
    redirect: "/punch-competition",
  },
  {
    path: "/teaser",
    name: "JamesonTeaser",
    component: () => import("@/views/JamesonTeaser.vue"),
  },
  {
    path: "/ireland",
    redirect: "/teaser",
  },
  {
    path: '/unsubscribe/:leadId',
    name: 'Unsubscribe',
    // Ленивая загрузка компонента
    component: () => import('@/views/UnsubscribeView.vue') 
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});
// Глобальный guard для проверки возраста
router.beforeEach((to, from, next) => {
    // const userAge = JSON.parse(localStorage.getItem('userAge'));

    // если идём на главную и возраст есть → сразу на /chivas
    // if (to.path === "/") {
    //   if (userAge) {
    //     return next("/jameson");
    //   }
    //   return next(); // иначе остаёмся на главной
    // }

    // // если идём на /chivas, но возраста нет → возвращаем на /
    // if (to.path === "/jameson" && !userAge) {
    //   return next("/");
    // }

    next();
});

export default router;
